import React from 'react';
import Config from '../utils/config';

export default function Footer ({SiteTitle, Label}) {
    const popWin = (opentype) => {
        let wx = 800,
            wy = 630;
        if (navigator.appVersion.indexOf('Chrome') > 0) { wx += 100; }
        let x = (screen.width - wx) / 2;
        let y = x = (screen.height - wx) / 2;
        if (x < 0) { x = 0; }
        if (y < 0) { y = 0; }
        window.open('newIndex/popupFooter?Type=' + opentype, SiteTitle, 'left=' + x + ',top=' + y + ',width=' + wx + ',height=' + wy + ",location=no,resizable=no,scrollbars=yes");    
    }

    const popLink = (url, title) => {
        let wx = 800,
            wy = 630;
        if (navigator.appVersion.indexOf('Chrome') > 0) { wx += 100; }
        let x = (screen.width - wx) / 2;
        let y = x = (screen.height - wx) / 2;
        if (x < 0) { x = 0; }
        if (y < 0) { y = 0; }
        window.open(url, title, 'left=' + x + ',top=' + y + ',width=' + wx + ',height=' + wy + ",location=no,resizable=no,scrollbars=yes");    
    }
    return (
        <footer className="footer-wrapper">
            <div className="footer">
                <ul>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("aboutUs")}}>{Label.lbl_AboutUs}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("contactUs")}}>{Label.lbl_ContactUs}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("howToBet")}}>{Label.lbl_howToBet}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("rulesRegulations")}}>{Label.lbl_ruleregulation}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("termsConditions")}}>{Label.lbl_Termandconditions}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("responsibleGaming")}}>{Label.lbl_ResponsibleGaming}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("termsOfUse")}}>{Label.lbl_Termsofuse}</a></li>
                    <li><a href="javascript:void(0);" onClick={()=> {popWin("privacyPolicy")}}>{Label.lbl_PrivacyPolicy}</a></li>
                    {Config.appConfig.SiteID == '4240700' ?
                        <li><a href="javascript:void(0);" onClick={()=> {popLink("https://www.pagcor.ph/index.php", "PAGCOR Official website")}}>Pagcor</a></li>
                        : ''
                    }
                </ul>
            </div>
            <span dangerouslySetInnerHTML={{ __html: '©' + Label.lbl_Copyright }}></span>
        </footer>
    );
}